module.exports = __webpack_public_path__ + "img/d4a7ebc.png";